import React from "react";
import CheckmateLounge from "./CheckmateLounge";

function App() {
  return <CheckmateLounge />;
}

export default App;

